/* ──────────────────────────────────────────────────────────────
   src/components/prevision/ProfesoresModal.tsx
   Modal para mostrar lista de profesores activos
   ────────────────────────────────────────────────────────────── */
import { Close as CloseIcon } from '@mui/icons-material';
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';
import { useState, useEffect } from 'react';

import apiClient from '../../api/client';

interface Profesor {
  id: number;
  nombreCompleto: string;
  email: string;
}

interface ProfesoresModalProps {
  open: boolean;
  onClose: () => void;
  profesoresIds: number[];
  titulo: string;
}

export default function ProfesoresModal({ open, onClose, profesoresIds, titulo }: ProfesoresModalProps) {
  const [profesores, setProfesores] = useState<Profesor[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && profesoresIds.length > 0) {
      setLoading(true);
      // Obtener detalles de los profesores
      apiClient
        .get<Profesor[]>('/prevision-profesores/profesores', {
          params: {
            ids: profesoresIds.join(','),
          },
        })
        .then((data) => {
          setProfesores(data);
        })
        .catch((error) => {
          console.error('Error cargando profesores:', error);
          setProfesores([]);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [open, profesoresIds]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="h6">{titulo}</Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
        <Typography variant="body2" color="text.secondary">
          {profesoresIds.length} {profesoresIds.length === 1 ? 'profesor' : 'profesores'}
        </Typography>
      </DialogTitle>
      <DialogContent>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
            <CircularProgress size={32} />
          </Box>
        ) : (
          <List>
            {profesores.map((prof) => (
              <ListItem key={prof.id}>
                <ListItemText
                  primary={prof.nombreCompleto}
                  secondary={prof.email}
                />
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
    </Dialog>
  );
}
